/* JAGUNG — Theme JS */
(function () {
  'use strict';

  // Mobile menu toggle
  const toggle = document.querySelector('[data-menu-toggle]');
  const nav = document.querySelector('[data-site-nav]');
  if (toggle && nav) {
    toggle.addEventListener('click', () => {
      const open = nav.classList.toggle('site-nav--open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  // Reveal-on-scroll
  if ('IntersectionObserver' in window) {
    const io = new IntersectionObserver((entries) => {
      entries.forEach((e) => {
        if (e.isIntersecting) {
          e.target.classList.add('is-visible');
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.12 });
    document.querySelectorAll('[data-reveal]').forEach((el) => io.observe(el));
  }

  // Marquee duplicator (so it loops seamlessly)
  document.querySelectorAll('.announce__track').forEach((track) => {
    track.innerHTML += track.innerHTML;
  });

  // Quantity inputs (simple)
  document.querySelectorAll('[data-qty-minus]').forEach((b) =>
    b.addEventListener('click', () => {
      const input = b.parentElement.querySelector('input');
      const v = Math.max(1, parseInt(input.value || '1', 10) - 1);
      input.value = v;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    })
  );
  document.querySelectorAll('[data-qty-plus]').forEach((b) =>
    b.addEventListener('click', () => {
      const input = b.parentElement.querySelector('input');
      const v = parseInt(input.value || '1', 10) + 1;
      input.value = v;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    })
  );
})();
